/* PagingActivityFeed.js */

const PagingFeed = require("../../../../lib/PagingFeed");

const mongoDbQuery = {
    $or: [
        {
            activityType: "create",
        },
        {
            activityType: "update",
        },
        {
            activityType: "remove",
        },
        {
            activityType: "relAdd",
        },
        {
            activityType: "relRemove",
        },
        {
            activityType: "relSet",
        },
        {
            activityType: "jobStatus",
        },
    ],
};

class PagingActivityFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startRelatedAuditsFeed(
            mongoDbQuery,
            this._entityFields,
            this._sort,
            {
                skip: 0,
                limit: this._pageSize * 2,
            }
        );
    }

    _feedReestablish() {
        return this._feed.reestablishFeed(
            this._userSession.activeOrganization.id,
            mongoDbQuery,
            this._entityFields,
            this._sort
        );
    }

    _feedShutDown() {
        return this._EntityDef.stopRelatedAuditsFeed();
    }
}

module.exports = PagingActivityFeed;
